import { Routes, Route } from 'react-router-dom';
import Home from '../pages/website/Home';
import Terms from '../pages/website/Terms';
import Privacy from '../pages/website/Privacy';
import RefundPolicy from '../pages/website/RefundPolicy';
import Scan from '../pages/website/Scan';
import VendorView from '../pages/website/VendorView';
import WebLayout from '../layout/website/DefaultLayout';

export default function WebRoutes() {
  return (
    <Routes>
      <Route path="/" element={<WebLayout />}>
        <Route index element={<Home />} />
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="refund-policy" element={<RefundPolicy />} />
        <Route path="scan/:qrId" element={<Scan />} />
        <Route path="vendor/:vendorId" element={<VendorView />} />
      </Route>
    </Routes>
  );
}